import React from 'react';
import { DrawerProps as AntDrawerProps } from 'antd';
import { StyledDrawer } from './DrawerStyles';

export type TDrawerProps = AntDrawerProps;

const maskStyles: React.CSSProperties = {
  backdropFilter: 'blur(3.5px)',
  backgroundColor: 'rgba(55, 55, 99, 0.43)',
};

const Drawer: React.FC<TDrawerProps> = (props) => {
  return (
    <StyledDrawer
      styles={{
        mask: maskStyles,
      }}
      {...props}
    />
  );
};

export default Drawer;
